import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Set a project's settings
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetProjectSettings = packet => {
  return {
    type: 'REQUEST_SET_PROJECT_SETTINGS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetProjectSettingsSuccess = data => ({
  type: 'RECEIVE_SET_PROJECT_SETTINGS_SUCCESS',
  data
})

export const receiveSetProjectSettingsFail = data => ({
  type: 'RECEIVE_SET_PROJECT_SETTINGS_FAIL',
  data
})

export const tryToSetProjectSettings = packet => (dispatch, getState) => {

  dispatch(requestSetProjectSettings(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/settings/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetProjectSettingsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSetProjectSettingsFail({errors:e, lastSubmit: packet}));
    })
}
